import config from "../../../config";
import makeAPIRequest from "../../../services/makeRequest";

async function getAllImpactStats(accessToken, query = "") {
  const API_ENDPOINT = `${config["API_BASE_ENDPOINT"]}/admin/impactdashboard${query}`;
  const response = await makeAPIRequest(API_ENDPOINT, "GET", null, accessToken);
  const jsonResponse = await response.json();
  return jsonResponse;
}

export default getAllImpactStats;
